module.exports = __webpack_public_path__ + "img/Martin Reyes.1e7b7b27.jpg";